import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperPlane: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPaperPlane"><Path d="M4.71863 11L2.50195 2.1333L22.2355 12.0001L2.50195 21.8668L4.71866 13H9.99943V11H4.71863Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPaperPlane;
